import React, { useCallback, useState, useEffect } from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import PopupWrapper from '../../../components/Popup/PopupWrapper';
import PopupHeader from '../../../components/Popup/PopupHeader';
import PopupBody from '../../../components/Popup/PopupBody';
import * as actions from '../../../../redux/user/actions.user';
import asyncDispatch from '../../../../services/mini/asyncDispatch';
import BillingForms from '../BillingForms/BillingForms';
import errorMessages from '../../../../const/errorMessages';
import withClickOutsideOnOverlay from '../../../../hoc/withClickOutsideOnOverlay';
import { reachMetrikaGoal } from '../../../../services/MetrikaService';
import errorCodes from '../../../../const/errorCodes';


function AddFundsPopup({
    amount,
    currentPlan,
    nextPlan,
    onBillingFinishedCb,
    onClose,
    hideCardsBtn,
    cards,
    store,
    error
}) {

    useEffect(() => {
        reachMetrikaGoal('viewedAddFundsModal');
    });

    const onCloseCb = useCallback(() => {
        reachMetrikaGoal('closeAddFundsModal');
        onClose();
    }, [onClose]);

    const hidePaypalBtn = nextPlan?.isPeriodic || currentPlan.isPeriodic;
    const hideCardsBtnSection = true;
    
    let formTitle = hidePaypalBtn ? '' : 'Choose your payment method';
    let stripeFormTitle = !hideCardsBtnSection ? 'Pay with new Credit Card' : 'Pay with Credit Card';
    let refund = false;
    let stripeBtnTitle = null;
    let infoMsg;
    let readOnlyAmount = false;

    if (nextPlan?.isPeriodic) {
        formTitle = 'Please provide a credit card for subscription payments';
        infoMsg = 'This amount will be charged at the beginning of a new period.';
    }

    if (error === errorCodes.cardVerificationRequired) {
        stripeFormTitle = 'Credit Card Info';
        refund = true;
        error = null;
        stripeBtnTitle = 'Save Card';
        readOnlyAmount = true;
        if (nextPlan?.isPeriodic) {
            formTitle = 'Please provide a credit card for subscription payments';
            infoMsg = `We need to verify your credit card. This amount will be refunded back shortly, and you will be automatically charged $${nextPlan.price} at the beginning of a new period.`;
        }
    } else if (error === errorCodes.notEnoughMoney && nextPlan?.isPeriodic) {
        infoMsg = `We will charge partial amount for the first period, and you will be automatically charged $${nextPlan.price} at the beginning of a new period.`;
        error = null;
    }

    return (
        <PopupWrapper className="billing-popup">
            <PopupHeader
                title={formTitle}
                onCancel={onCloseCb} />
            <PopupBody className="billing-popup_body">
                {error && <span className="billing-popup_err-msg">{errorMessages[error]}</span>}
                <BillingForms
                    nextPlan={nextPlan}
                    infoMsg={infoMsg}
                    amount={amount}
                    refund={refund}
                    readOnlyAmount={readOnlyAmount}
                    store={store}
                    hidePromoCodeBtn={true}
                    hidePaypalBtn={hidePaypalBtn}
                    expandCardsSection={!hideCardsBtnSection}
                    expandStripeSection={hidePaypalBtn && hideCardsBtnSection}
                    hideCardsBtn={hideCardsBtnSection}
                    stripeFormTitle={stripeFormTitle}
                    stripeBtnTitle={stripeBtnTitle}
                    onBillingFinishedCb={onBillingFinishedCb} />
            </PopupBody>
        </PopupWrapper>
    );
}

function mapStateToProps({ user }, ownProps) {
    return {
        balance: user.balance,
        paidUntilTs: user.paidUntilTs,
        currentPlan: user.currentPlan,
        billingStatus: user.billingStatus,
        cards: user.cards,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        getPlans: () => dispatch(actions.getPlans()),
        changePlan: (param) => asyncDispatch(actions.changePlan, dispatch, param),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(withClickOutsideOnOverlay(AddFundsPopup));
